import React from "react"

import styles from "./styles.module.scss"
import classNames from "classnames"

interface SwitcherItem {
	name: string
	label: string
	active: boolean
}

interface Props {
	className?: string
	data: SwitcherItem[]
	setActive: Function
}

export default function Switcher(props: Props) {
	return (
		<ul className={classNames(styles.switcher, props.className)}>
			{props.data.map(switcherItem => (
				<li key={switcherItem.name} className={styles.switcher__item}>
					<button
						onClick={() => props.setActive(switcherItem.name)}
						type={"button"}
						className={classNames(styles.switcher__button, {
							[styles.switcher__buttonActive]: switcherItem.active,
						})}
					>
						{switcherItem.label}

						{switcherItem.name === "year"}
					</button>
				</li>
			))}
		</ul>
	)
}
